// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rd-6";
export var imgContainer = "_rd-3";
export var menuIcon = "_rd-5";
export var pillWrapper = "_rd-2";
export var pillsContainer = "_rd-1";
export var subscriptionCard = "_rd-0";
export var subscriptionLogo = "_rd-4";